const Section1 = ({ isMobile, setOpen }) => {
  return (
    <div
      style={{ padding: 20, backgroundColor: "#f2efeb" }}
      // className="fade-in-section1"
    >
      <div
        style={{
          height: "100%",
          backgroundColor: "#f2efeb",
          display: "flex",
          flexDirection: "column",
          border: "solid #810605",
          borderRadius: 20,
          alignItems: "center",
        }}
      >
        <div style={{ height: 50, paddingLeft: 20 }} />
        <div className="fade-in-section1" style={{ width: "50%" }}>
          <h2 style={{ margin: 0, fontFamily: "Montserrat", color: "#810605" }}>
            YOU'RE INVITED TO THE:
          </h2>
        </div>
        <div
          className="fade-in-section1"
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <h1
            style={{
              fontFamily: "BrushScriptOpti-Regular",
              color: "#810605",
              fontSize: isMobile ? "7rem" : "8rem",
              transform: "rotate(-10deg)",
              margin: 0,
              fontWeight: 300,
            }}
          >
            Wedding
          </h1>
          <p></p>
        </div>
        <div
          className="fade-in-section1"
          style={{
            width: "90%",
            paddingTop: 20,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            paddingRight: isMobile ? 0 : 40,
          }}
        >
          <h2
            style={{
              marginBottom: 10,
              fontFamily: "Montserrat",
              color: "#810605",
              fontSize: isMobile ? "1.2rem" : "1rem",
            }}
          >
            CELEBRATION OF
          </h2>
          <h2
            style={{
              margin: 0,
              fontFamily: "BrushScriptOpti-Regular",
              color: "#810605",
              fontSize: isMobile ? "3rem" : "4rem",
              fontWeight: 300,
            }}
          >
            Andrea Ramirez &
          </h2>
          <h2
            style={{
              margin: 0,
              fontFamily: "BrushScriptOpti-Regular",
              color: "#810605",
              fontSize: "4rem",
              fontWeight: 300,
              fontSize: isMobile ? "3rem" : "4rem",
            }}
          >
            David Greenberg
          </h2>
          <p
            style={{
              fontFamily: "Montserrat",
              color: "#810605",
              fontSize: "1.5rem",
              marginTop: 40,
            }}
          >
            Saturday, November 15, 2025
          </p>
          <p
            style={{
              fontFamily: "BrushScriptOpti-Regular",
              color: "#810605",
              fontSize: "3rem",
              margin: 0,
              cursor: "pointer",
            }}
            onClick={() =>
              window.open("https://maps.app.goo.gl/CbQzdgLV8XU26jo99", "_blank")
            }
          >
            The Oviatt Penthouse
          </p>
          <p
            style={{
              fontFamily: "Montserrat",
              color: "#810605",
              fontSize: "1.5rem",
              margin: 0,
              cursor: "pointer",
            }}
            onClick={() =>
              window.open("https://maps.app.goo.gl/CbQzdgLV8XU26jo99", "_blank")
            }
          >
            617 S Olive St, Los Angeles, CA 90014
          </p>
        </div>
        <div style={{fontFamily: "Montserrat", fontSize: isMobile ? "1rem" : "1.2rem", marginTop: 20, display:'flex', flexDirection: "column", gap: 10}}>
          <p style={{margin:0}}>ADULTS ONLY CELEBRATION</p>
          <p style={{margin: 0,}}>DINNER AND DANCING TO FOLLOW</p>
        </div>
        <div style={{ height: 30 }} />
        <div
          style={{
            width: isMobile ? "50%" : "20%",
            height: 30,
            border: "solid #810605",
            borderRadius: 15,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: 'pointer'
          }}
        >
          <p style={{fontFamily: "Montserrat", color: "#810605"}} onClick={() => setOpen(true)}>RSVP HERE</p>
        </div>
        <div style={{ height: 30 }} />
      </div>
    </div>
  );
};

export default Section1;
